{
  "heading": "Mon compte",
  "logout": "Se déconnecter",
  "unverifiedBanner": "Votre adresse email n'est pas encore confirmée. Certaines actions resteront indisponibles.",
  "readOnlyNotice": "Confirmez votre adresse email pour pouvoir modifier votre compte.",
  "saved": "Modifications enregistrées.",
  "save": "Enregistrer",
  "saving": "Enregistrement…",
  "identity": {
    "heading": "Identité",
    "email": "Adresse email",
    "emailHint": "Le changement d'adresse arrivera avec la vérification du nouveau destinataire.",
    "firstName": "Prénom",
    "lastName": "Nom",
    "displayName": "Nom affiché",
    "displayNameHint": "Laissez vide pour afficher « prénom nom ».",
    "locale": "Langue",
    "timezone": "Fuseau horaire",
    "roles": "Rôles",
    "permissionCount": "Permissions"
  },
  "profile": {
    "heading": "Profil",
    "intro": "Ces informations sont visibles par les autres utilisateurs de la plateforme.",
    "headline": "Titre",
    "headlinePlaceholder": "Professeure de mathématiques",
    "bio": "Présentation",
    "bioHint": "{{count}} caractères au maximum.",
    "subjects": "Matières",
    "subjectsHint": "Séparez par des virgules.",
    "languages": "Langues enseignées",
    "website": "Site web",
    "websiteHint": "Adresse complète, commençant par https://",
    "verified": "Profil vérifié"
  },
  "preferences": {
    "heading": "Préférences",
    "shareProgress": "Partager ma progression avec mes enseignants",
    "shareProgressHint": "Hors des cours auxquels vous êtes inscrit. Vous pouvez revenir sur ce choix à tout moment.",
    "marketingEmails": "Recevoir les actualités de la plateforme",
    "marketingEmailsHint": "Les emails liés à votre compte et à vos cours vous sont envoyés dans tous les cas.",
    "consentNotice": "Vos choix de partage sont datés et conservés, afin que vous puissiez savoir depuis quand ils s'appliquent.",
    "theme": "Thème",
    "themes": {
      "system": "Comme mon système",
      "light": "Clair",
      "dark": "Sombre"
    }
  },
  "privacy": {
    "heading": "Mes données",
    "export": {
      "heading": "Exporter mes données",
      "description": "Téléchargez l'ensemble des données conservées à votre sujet : compte, profil, préférences, rôles, sessions actives et historique daté de vos consentements. Le fichier est au format JSON.",
      "action": "Télécharger mes données",
      "pending": "Préparation…",
      "done": "Le téléchargement a démarré."
    },
    "deletion": {
      "heading": "Supprimer mon compte",
      "description": "Votre compte sera anonymisé 30 jours après votre demande. Vos données identifiantes seront effacées ; ce que vous avez publié restera, sans plus vous désigner. Vous pouvez revenir sur votre décision jusqu'à cette date.",
      "start": "Supprimer mon compte",
      "confirmLabel": "Saisissez {{email}} pour confirmer.",
      "confirm": "Confirmer la suppression",
      "abort": "Annuler",
      "scheduled": "Votre compte sera supprimé le {{date}}.",
      "stillUsable": "Jusqu'à cette date, votre compte fonctionne normalement et vous pouvez revenir sur votre décision.",
      "cancel": "Conserver mon compte"
    }
  },
  "sessions": {
    "heading": "Sessions actives",
    "revoke": "Fermer",
    "current": "(session courante)",
    "unknownDevice": "Appareil inconnu",
    "lastUsed": "Dernière activité le {{date}}",
    "loading": "Chargement des sessions…"
  },
  "loading": "Chargement de votre compte…",
  "languages": {
    "fr": "Français",
    "en": "Anglais"
  }
}
